module.exports = __webpack_public_path__ + "img/shuang1.2aaeb618.png";